import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { hash } from 'rsvp';
import Transition from '@ember/routing/-private/transition';

import ActionsEmailSendingDomainsController from 'cio/pods/actions/email/sending-domains/controller';
import DS from 'ember-data';

export default class ActionsEmailSendingDomains extends Route {
  @service store!: DS.Store;

  crumb() {
    return {
      name: 'Sending Domains',
      path: 'actions.email.sending_domains',
    };
  }

  model() {
    return hash({
      domains: this.modelFor('actions.email'),
      identities: this.store.query('identity', { type: 'email' }),
      identitiesInUse: this.store.query('identity', { in_use: true }),
      mailServers: this.store.findAll('mail-server'),
    });
  }

  resetController(controller: ActionsEmailSendingDomainsController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setDefaults();
    }
  }
}
